import { CardBackground, Typography } from "@hellocarbo/lasagne";
import { cn } from "@hellocarbo/lasagne/utils";
import { useTranslation } from "react-i18next";

const ImportCount = ({ count }: { count: number }) => {
  const { t } = useTranslation(["formatter", "onboarding"]);

  return (
    <CardBackground className="gap-sm border-grayscale-xx-light flex flex-row-reverse items-center justify-end border lg:flex-row lg:justify-between">
      <Typography step="0" as="h3" weight="semibold">
        {t("onboarding:collect.import.title")}
      </Typography>

      <div
        className={cn(
          "gap-2xs px-2xs py-3xs w-2xl rounded-full text-center",
          count > 0 ? "bg-warning-xx-light" : "bg-positive-xx-light"
        )}
      >
        <Typography
          step="-2"
          className={cn(count > 0 ? "text-warning" : "text-positive")}
          weight="semibold"
        >
          {t("formatter:number", { value: count })}
        </Typography>
      </div>
    </CardBackground>
  );
};

export default ImportCount;
